@if (imgSrc.value()) {
  <img [src]="imgSrc.value()" />
} @else if (!imgSrc.value() && defaultImage()) {
  <img [src]="defaultImage()" />
} @else if (!imgSrc.value() && !defaultImage() && defaultIcon()) {
  <app-fa-dynamic-icon [icon]="defaultIcon()"></app-fa-dynamic-icon>
}
